// import React, { useState } from "react";
// import { motion } from "framer-motion";
// import PersonImage from "../Component/workcolleagues-e1666310285630.jpg";  
// const BusinessPromo = () => {
//   const [showPopup, setShowPopup] = useState(false);

//   const togglePopup = () => {
//     setShowPopup(!showPopup);
//   };

//   return (
//     <>
//       <style>{`
//         .containerss {
//           display: flex;
//           flex-direction: row;
//           align-items: center;
//           justify-content: space-between;
//           padding: 50px;
//           font-family: Arial, sans-serif;
//           height: auto;
//         //    margin-top:30px;
//           background-color:rgb(255,255,255,0.0);
//           overflow: hidden;
//           flex-wrap: wrap;
//         //   padding-top: 1px;
//         //   padding-bottom: 1px;
//         }

//         .text-sectiony {
//           max-width: 50%;
//           text-align: left;
//         }

//         .image-sectiony {
//           display: flex;
//           justify-content: flex-start;
//           width: 50%;
//         }

//         .imagess {
//           width: 100%;
//           max-width: 681px;
//           border-radius: 10px;
//         }

//         .headingyss {
//           font-size: 36px;
//           font-weight: bold;
//           color: white;
//           text-align:left;
//         }

//         .bold {
//           color: #ffe124;
//         }

//         .highlighted {
//           color: #0e7f9d;
//           border-bottom: 3px solid #ffe124;
//           display: inline-block;
//           text-align:left;
//         }

//         .paragraph {
//           font-size: 17px;
//           color: white;
//           margin: 10px 0 20px;
//           text-align:left;
//           font-family: 'Poppins', sans-serif;
          
//         }

//         .buttonContainer {
//           margin-top: 20px;
//         }

//         .downloadBtn {
//           background-color: #ffe124;
//           color: #2a0947;
//           padding: 12px 25px;
//           font-size: 20px;
//           border: none;
//           border-radius: 8px;
//           cursor: pointer;
//           transition: 0.3s ease;
//           font-weight: bold;
//         }

//         .popupOverlay {
//           position: fixed;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           background: rgba(0, 0, 0, 0.5);
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           z-index: 1000;
//         }

//         .popupInner {
//           background: white;
//           padding: 30px;
//           border-radius: 10px;
//           text-align: center;
//           position: relative;
//           max-width: 400px;
//           animation: slideUp 0.4s ease;
//         }

//         .closeBtn {
//           position: absolute;
//           top: 10px;
//           right: 15px;
//           font-size: 20px;
//           background: none;
//           border: none;
//           cursor: pointer;
//         }

//         .scannerImg {
//           width: 200px;
//           height: auto;
//           margin-bottom: 15px;
//         }

//         @media (max-width: 768px) {
//           .containerss {
//             flex-direction: column-reverse;
//             height: auto;
//           }

//           .text-sectiony,
//           .image-sectiony {
//             max-width: 100%;
//             width: 100%;
//             text-align: center;
//             justify-content: center;
//           }

//           .headingyss {
//             font-size: 36px;
//           }

//           .imagess {
//             max-width: 90%;
//             margin: 0 auto;
//           }
//         }

//         @media (max-width: 480px) {
//           .headingyss {
//             font-size: 30px;
//           }

//           .paragraph {
//             font-size: 14px;
//           }

//           .downloadBtn {
//             font-size: 16px;
//             padding: 10px 20px;
//           }

//           .scannerImg {
//             width: 150px;
//           }
//         }
//       `}</style>

//       <div className="containerss">
//         {/* Image Section - LEFT */}

//         {/* Text Section - RIGHT */}

//         <motion.div
//           className="image-sectiony"
//           initial={{ opacity: 0, x: -50 }}
//           animate={{ opacity: 1, x: 0 }}
//           transition={{ duration: 1, ease: "easeOut" }}
//         >
//           <img src={PersonImage} alt="Person" className="imagess" />
//         </motion.div>

//         <motion.div
//           className="text-sectiony"
//           initial={{ opacity: 0, y: 50 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1, ease: "easeOut" }}
//         >
//           <p className="headingyss">
//             About <span className="bold">Us</span> <br />
//             {/* <span className="bold"></span>  <br /> */}
//           </p>

//           <p className="paragraph">
//             Envision Integrated Services function as a full stakeholder to
//             business, offering a consulting-led approach with an integrated
//             portfolio of technology that encompass the entire enterprise value
//             chain. Our Customer-centric engagement model defines how we engage
//             with you, offering specialized services and solutions that meet the
//             distinct needs of your business
//           </p>
//           <p className="paragraph">
//             Through a combination of deep industry expertise and cutting-edge
//             digital capabilities, we empower organizations to drive innovation,
//             improve operational efficiency, and achieve sustainable growth. By
//             aligning technology strategies with business goals, we ensure
//             measurable impact and long-term value for every client engagement.
//           </p>

//           <p className="paragraph">
//             We empower to provide customers a single window to industry specific
//             solutions, route them to deliver their business goals and drive
//             technology led transformations.
//           </p>
//         </motion.div>
//       </div>
//     </>
//   );
// };

// export default BusinessPromo;




import React, { useState } from "react";
import { motion } from "framer-motion";
import PersonImage from "../Component/workcolleagues-e1666310285630.jpg";

const BusinessPromo = () => {
  const [showPopup, setShowPopup] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  return (
    <>
      <style>{`
        .containerss {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          padding: 50px;
          font-family: Arial, sans-serif;
          height: auto;
          background-color: #ffffff;
          overflow: hidden;
          flex-wrap: wrap;
          // max-width: 1200px;
          margin: 0 auto;
          border-radius: 10px; 
          margin-top:20px;
        }

        .text-sectiony {
          max-width: 50%;
          text-align: left;
        }

        .image-sectiony {
          display: flex;
          justify-content: flex-start;
          width: 50%;
        }

        .imagess {
          width: 90%;
          max-width: 681px;
          border-radius: 10px;
        }

        .headingyss {
          font-size: 36px;
          font-weight: bold;
          color: #0e7f9d;
          text-align:left;
        }

        .bold {
          color: #ffe124;
        }

        .highlighted {
          color: #0e7f9d;
          border-bottom: 3px solid #ffe124;
          display: inline-block;
          text-align:left;
        }

        .paragraph {
          font-size: 17px;
          color: #2a0947;
          margin: 10px 0 20px;
          text-align:left;
          font-family: 'Poppins', sans-serif;
        }

        .buttonContainer {
          margin-top: 20px;
        }

        .downloadBtn {
          background-color: #ffe124;
          color: #2a0947;
          padding: 12px 25px;
          font-size: 20px;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          transition: 0.3s ease;
          font-weight: bold;
        }

        .popupOverlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }

        .popupInner {
          background: white;
          padding: 30px;
          border-radius: 10px;
          text-align: center;
          position: relative;
          max-width: 400px;
          animation: slideUp 0.4s ease;
        }

        .closeBtn {
          position: absolute;
          top: 10px;
          right: 15px;
          font-size: 20px;
          background: none;
          border: none;
          cursor: pointer;
        }

        .scannerImg {
          width: 200px;
          height: auto;
          margin-bottom: 15px;
        }

        @media (max-width: 768px) {
          .containerss {
            flex-direction: column-reverse;
            height: auto;
            padding: 30px 20px;
          }

          .text-sectiony,
          .image-sectiony {
            max-width: 100%;
            width: 100%;
            text-align: center;
            justify-content: center;
          }

          .headingyss {
            font-size: 28px;
          }

          .imagess {
            max-width: 90%;
            margin: 0 auto;
          }
        }

        @media (max-width: 480px) {
          .headingyss {
            font-size: 24px;
          }

          .paragraph {
            font-size: 14px;
          }

          .downloadBtn {
            font-size: 16px;
            padding: 10px 20px;
          }

          .scannerImg {
            width: 150px;
          }
        }
      `}</style>

      <div className="containerss">
        {/* Image Section - LEFT */}
        <motion.div
          className="image-sectiony"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <img src={PersonImage} alt="Person" className="imagess" />
        </motion.div>

        {/* Text Section - RIGHT */}
        <motion.div
          className="text-sectiony"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <p className="headingyss">
            About <span className="bold">Us</span>
          </p>

          <p className="paragraph">
            Envision Integrated Services function as a full stakeholder to
            business, offering a consulting-led approach with an integrated
            portfolio of technology that encompass the entire enterprise value
            chain. Our Customer-centric engagement model defines how we engage
            with you, offering specialized services and solutions that meet the
            distinct needs of your business.
          </p>
          <p className="paragraph">
            Through a combination of deep industry expertise and cutting-edge
            digital capabilities, we empower organizations to drive innovation,
            improve operational efficiency, and achieve sustainable growth. By
            aligning technology strategies with business goals, we ensure
            measurable impact and long-term value for every client engagement.
          </p>

          <p className="paragraph">
            We empower to provide customers a single window to industry-specific
            solutions, route them to deliver their business goals and drive
            technology-led transformations.
          </p>
        </motion.div>
      </div>
    </>
  );
};

export default BusinessPromo;
